import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $QuotationLine = styled.div<{
  $isActive: boolean;
  $isSelected?: boolean;
  $isFluid: boolean;
}>`
  text-align: left;
  opacity: ${({ $isSelected = true }) => ($isSelected ? undefined : 0.4)};

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: ${({ $isFluid }) => ($isFluid ? '100%' : null)};

  padding: ${spacing('lg')} 0;
  color: ${({ theme, $isActive }) =>
    $isActive ? theme.colors.mainTextColor : theme.colors.paragraphTextColor};

  & > div:first-child {
    display: flex;
    justify-content: space-between;
    margin-bottom: ${spacing('sm')};
  }
`;

export const $AmountCell = styled.div`
  text-align: right;
  white-space: nowrap;
  margin-left: ${spacing('sm')};
`;

export const $SparePartLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
`;
